(() => {
  const EDGE_OFFSET = 16;
  const BOTTOM_OFFSET = 20;
  const SAFE_BOTTOM_OFFSET = `calc(${BOTTOM_OFFSET}px + env(safe-area-inset-bottom, 0px))`;

  const applyStyle = (element, declarations) => {
    if (!element) return;

    Object.entries(declarations).forEach(([property, value]) => {
      element.style.setProperty(property, value, 'important');
    });
  };

  const getWidgetControls = () => {
    const accessibilityHost = document.querySelector('csm-web-accessibility');
    const privacyHost = document.querySelector('csm-cookie-consent');
    const chatHost = document.querySelector('#interactor-embed-chat');

    const accessibility = accessibilityHost?.shadowRoot?.querySelector('#csm-ada-compliance-wrapper');
    const accessibilityToggle = accessibilityHost?.shadowRoot?.querySelector('#csm-ada-toggle-widget-button');
    const privacy = privacyHost?.shadowRoot?.querySelector('#reopen_widget')?.parentElement;
    const chat = chatHost?.shadowRoot?.querySelector('#interactor-fab');
    const chatFrame = chatHost?.shadowRoot?.querySelector('#interactor-chat-iframe');

    return { accessibility, accessibilityToggle, privacy, chat, chatFrame };
  };

  const waitForAccessibilityApi = () => new Promise((resolve, reject) => {
    let attempts = 0;

    const check = () => {
      const accessibilityApi = window.Consentmo?.accessibility;
      if (typeof accessibilityApi?.open === 'function') {
        resolve(accessibilityApi);
        return;
      }

      attempts += 1;
      if (attempts < 40) {
        window.setTimeout(check, 250);
        return;
      }

      reject(new Error('Accessibility tools are still loading'));
    };

    check();
  });

  const bindAccessibilityTriggers = () => {
    document.querySelectorAll('[data-accessibility-widget-trigger]').forEach((trigger) => {
      if (trigger.dataset.accessibilityTriggerBound === 'true') return;

      trigger.dataset.accessibilityTriggerBound = 'true';
      trigger.addEventListener('click', async () => {
        if (trigger.getAttribute('aria-busy') === 'true') return;

        trigger.setAttribute('aria-busy', 'true');
        try {
          const accessibilityApi = await waitForAccessibilityApi();
          accessibilityApi.open();
        } catch {
          document.dispatchEvent(new CustomEvent('accessibility:widget-error'));
        } finally {
          trigger.removeAttribute('aria-busy');
        }
      });
    });
  };

  const updateControls = () => {
    const drawerIsOpen = document.querySelector('#Details-menu-drawer-container[open]') !== null;
    const hiddenState = drawerIsOpen ? '0' : '1';
    const interactionState = drawerIsOpen ? 'none' : 'auto';
    const footerAccessibilityTrigger = document.querySelector('[data-accessibility-widget-trigger]');
    const { accessibility, accessibilityToggle, privacy, chat, chatFrame } = getWidgetControls();

    chat?.setAttribute('aria-label', 'Open support chat');
    chatFrame?.setAttribute('title', 'Support chat');

    applyStyle(accessibility, {
      bottom: SAFE_BOTTOM_OFFSET,
      left: `${EDGE_OFFSET}px`,
      opacity: hiddenState,
      'pointer-events': interactionState,
      right: 'auto',
      top: 'auto',
      transition: 'opacity 160ms ease'
    });

    applyStyle(accessibilityToggle, {
      display: footerAccessibilityTrigger ? 'none' : 'block'
    });

    applyStyle(privacy, {
      display: 'none',
      opacity: '0',
      'pointer-events': 'none',
      right: 'auto',
      top: 'auto',
      visibility: 'hidden'
    });

    applyStyle(chat, {
      bottom: SAFE_BOTTOM_OFFSET,
      opacity: hiddenState,
      'pointer-events': interactionState,
      right: `${EDGE_OFFSET}px`,
      transition: 'opacity 160ms ease'
    });
  };

  const observeDrawer = () => {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    drawer?.addEventListener('toggle', updateControls);
  };

  const observer = new MutationObserver(() => {
    observeDrawer();
    bindAccessibilityTriggers();
    updateControls();
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', () => {
    observeDrawer();
    bindAccessibilityTriggers();
    updateControls();
  });

  window.setTimeout(updateControls, 500);
  window.setTimeout(updateControls, 1500);
  window.setTimeout(updateControls, 3000);
})();
